import React, { Component } from 'react';
import styled from 'styled-components';
import { Button } from 'components/common';
import { toast } from 'react-toastify';
import { db, timeStamp } from '../../auth/authService';
import uniqid from 'uniqid';
import emailjs from 'emailjs-com';

const ModalDialog = styled.div`
  width: 100%;
  height: 100%;
  max-height: 100%;
  overflow-y: auto;
  position: fixed;

  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  background: rgba(0, 0, 0, 0.9);
  z-index: 99999;
  opacity: ${props => (props.open ? '1' : '0')};

  -webkit-transition: opacity 100ms ease-in;
  -moz-transition: opacity 100ms ease-in;
  transition: opacity 100ms ease-in;
  pointer-events: ${props => (props.open ? 'auto' : 'none')};
`;
const StyledForm = styled.form`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 50rem;
  position: relative;
  top: 10rem;
  margin: 2.5% auto;
  padding: 2rem 3rem;
  border-radius: 3px;
  background: #434242;

  > a {
    position: absolute;
    right: 3rem;
    top: 2rem;
    font-size: 2rem;
    background: none;
    color: #fff;
    border: none;
    &:hover {
      color: #ff5c0b;
      cursor: pointer;
    }
  }
  > div {
    margin-top: 2rem;
    width: 40rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
  }
  > h1 {
    font-family: 'MuseoSans-500';
    font-size: 4rem;
    text-align: center;
    width: 30vw;
    color: #fff;
  }
  > p {
    font-family: 'MuseoSans-300';
    font-size: 1.6rem;
    text-align: center;
    width: 35vw;
    color: #fff;
  }
`;

const StyledField = styled.div`
  /* margin-top: 2rem; */
  /* width: 30rem; */
  width: 100%;
  height: 5rem;
  position: relative;
  margin-bottom: 1.4rem;
  /* padding: 0 2rem; */
  @media screen and (max-width: 1500px) {
    width: 100%;
  }
  > span {
    color: red;
    font-family: 'MuseoSans-300';
    font-size: 1.4rem;
    margin-top: 1rem;
  }
`;

const StyledInput = styled.input`
  float: left;
  font-size: 1.8rem;
  font-family: 'MuseoSans-300';
  padding: 1rem;
  display: block;
  width: 100%;
  color: #e8e8e8;
  background-color: transparent;

  border-style: none none solid none;
  border-width: 2px;
  border-color: ${props => (props.typed ? '#63d9d7' : '#e8e8e8')};

  &:focus {
    outline: 0;
    box-shadow: 0;
    border-style: none none solid none;
    border-width: 1px;
    border-color: #63d9d7;
  }
  &::placeholder {
    color: transparent;
  }

  &:focus ~ label {
    color: #63d9d7;
    top: -2.3rem;
    font-size: 1.2rem;
  }
`;

const StyledLabel = styled.label`
  color: ${props => (props.typed ? '#63d9d7' : '#e8e8e8')};
  position: absolute;
  font-size: ${props => (props.typed ? '1.2rem' : '1.6rem')};
  font-family: 'MuseoSans-300';
  left: 0;
  top: ${props => (props.typed ? '-1.4rem' : '1rem')};

  pointer-events: none;

  transition: 0.2s ease all;
  -moz-transition: 0.2s ease all;
  -webkit-transition: 0.2s ease all;
`;

const StyledTextField = styled.div`
  margin-top: 1.5rem;
  width: 100%;
  height: 28rem;
  position: relative;
  > span {
    display: inline-block;
    color: red;
    font-family: 'MuseoSans-300';
    font-size: 1.4rem;
  }
`;

const StyledTextLabel = styled.label`
  display: inline-block;
  margin: 1rem;
  color: #ff5c0b;
  font-size: 1.4rem;
  font-family: 'MuseoSans-300';

  pointer-events: none;
`;

const StyledTextArea = styled.textarea`
  float: left;
  font-size: 1.8rem;
  font-family: 'MuseoSans-300';
  padding: 1rem;
  display: block;
  width: 40rem;
  color: #fff;

  background-color: transparent;

  border-style: solid;
  border-width: 2px;
  border-color: ${props => (props.typed ? '#63d9d7' : '#fff')};
  resize: none;

  &:focus {
    outline: 0;
    box-shadow: 0;
    border-color: #63d9d7;
  }
  &::placeholder {
    color: transparent;
  }
`;

export class ContactUsModal extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {},
      errors: {},
      typed: {},
      formSubmitted: false
    };
  }

  handleChange = event => {
    const { name, value } = event.target;
    let fields = this.state.fields;
    let typed = this.state.typed;
    fields[name] = value;
    typed[name] = value.length !== 0;
    this.setState({ fields, typed });
    // console.log(this.state.typed);
  };

  handleSubmit = event => {
    event.preventDefault();

    if (this.validateForm()) {
      let { name, email, message } = this.state.fields;
      let createdAt = timeStamp.now();
      console.log(name);
      const templateParams = {
        name,
        email,
        message,
        createdAt
      };
      let uid = uniqid();
      console.log(uid);
      db.collection('messages')
        .doc(uid)
        .set({
          name,
          email,
          message,
          createdAt,
          ref: uid
        })
        .then(() => {
          emailjs.init('user_t4OCCsC1R3vIvsBhDmumK');
          emailjs
            .send('service_cz6erjd', 'template_jfryd7o', templateParams)
            .then(
              function(response) {
                console.log('success', response.status, response.text);
              },
              function(error) {
                console.log('failed', error);
              }
            );
        })
        .then(() => {
          this.setState({
            fields: {},
            errors: {},
            typed: {},
            formSubmitted: true
          });
          toast.success('form submitted');
        })
        .catch(err => console.log(err));
      this.props.handleClose(false);
    }
    this.setState({
      formSubmitted: false
    });
  };

  validateForm() {
    console.log('validating');
    let fields = this.state.fields;
    let errors = {};
    let formIsValid = true;

    const validEmailRegex = RegExp(
      /^(([^<>()\[\]\.,;:\s@\"]+(\.[^<>()\[\]\.,;:\s@\"]+)*)|(\".+\"))@(([^<>()[\]\.,;:\s@\"]+\.)+[^<>()[\]\.,;:\s@\"]{2,})$/i
    );

    //FIRST NAME VALIDATION
    if (!fields['name'] || fields['name'].trim().length === 0) {
      formIsValid = false;
      errors['name'] = '*Please enter your name.';
    }

    //EMAIL VALIDATION
    if (!fields['email'] || fields['email'].trim().length === 0) {
      formIsValid = false;
      errors['email'] = '*Please enter your E-mail Address.';
    } else {
      if (!validEmailRegex.test(fields['email'])) {
        formIsValid = false;
        errors['email'] = '*Please enter a valid E-mail Address.';
      }
    }

    //MESSAGE VALIDATION
    if (!fields['message'] || fields['message'].trim().length === 0) {
      formIsValid = false;
      errors['message'] = '*Please enter a message.';
    }

    // console.log(errors);

    this.setState({
      errors: errors
    });

    // console.log(this.state);

    return formIsValid;
  }

  render() {
    let { typed } = this.state;

    return (
      <>
        <ModalDialog open={this.props.open}>
          <StyledForm onSubmit={this.handleSubmit}>
            <a type='close' onClick={() => this.props.handleClose(false)}>
              X
            </a>

            <h1>CONTACT US</h1>
            <p>Feel free to fill out the form below to contact us!</p>
            <div>
              <StyledField>
                <StyledInput
                  type='text'
                  name='name'
                  id='name'
                  placeholder=''
                  onChange={this.handleChange}
                  typed={typed.name}
                />
                <StyledLabel htmlFor='name' typed={typed.name}>
                  Name
                </StyledLabel>
                {<span>{this.state.errors.name}</span>}
              </StyledField>

              <StyledField>
                <StyledInput
                  type='text'
                  name='email'
                  id='email'
                  placeholder=''
                  onChange={this.handleChange}
                  typed={typed.email}
                />
                <StyledLabel htmlFor='email' typed={typed.email}>
                  E-mail Address
                </StyledLabel>
                {<span>{this.state.errors.email}</span>}
              </StyledField>

              <StyledTextField>
                <StyledTextLabel htmlFor='message' typed={typed.message}>
                  MESSAGE
                </StyledTextLabel>
                <StyledTextArea
                  name='message'
                  id='message'
                  typed={typed.message}
                  onChange={this.handleChange}
                  cols='30'
                  rows='10'
                />
                {<span>{this.state.errors.message}</span>}
              </StyledTextField>
              <Button style={{ margin: '0 auto' }}>SUBMIT</Button>
            </div>
          </StyledForm>
        </ModalDialog>
      </>
    );
  }
}
